import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
export default {
  title: 'Subtitles configuration',
  attributeName: 'vodSubtitle',
  validationUrl:'vod',
  hiddenJsonComponent:true,
  fields: [
    {
      attributeName: 'uniqueId',
      label: 'UNIQUEID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'parentUID',
      label: 'PARENTUID',
      helpText: 'Unique id for tracing.',
      type: FormInputTypes.TEXT,
      hidden:true
    },
    {
      attributeName: 'captions',
      type: FormInputTypes.CHECKBOX,
      itemLabel: 'Captions',
      default: false,
      label: 'Captions',
      helpText: 'Are these captions subtitles?',
      errorText: '',
      classCss: "jsonComponent__width100",
    },
    {
      attributeName: 'subtitleVariant',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Subtitle available for this vod.',
      placeholder: 'text or number',
      label: 'Subtitles',
      required: true,
      errorText: '',
      visibleWhen:[{ field: "captions", value: "bool-false" }],
    },
    {
      attributeName: 'subtitleLanguage',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'Laguage available for this vod subtitle.',
      label: 'Language',
      pattern: /^[A-Za-z-]+$/,
      errorText: '',
    },
  ]
};
